import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { BaseResponse } from '../models/response/BaseResponse';
import { QrScanPreview } from '../models/QrScanPreview';

@Injectable({
  providedIn: 'root'
})
export class QrChallengeService extends HttpService {
  previewToken(token: string): Observable<BaseResponse<QrScanPreview>> {
    return this.post('qr-challenges/preview', { token });
  }
}
